import { fromCustomer } from "shared/analytics/useTrackOrder/mappers/analytics-customer.mapper";
import {
  trackSwapStarted,
  trackSwapFunnelStarted,
  trackSwapFunnelGradingCompleted,
  trackSwapFunnelShippingCompleted,
  trackSwapFunnelPaymentCompleted,
  trackSwapSelectionStarted,
} from "utils/analytics/analytics.utils";

import { fromOrder } from "./mappers/analytics-order.mapper";
import { useTrackSwapLazyQuery } from "./track-swap.query.generated";

type TrackingFunction =
  | typeof trackSwapStarted
  | typeof trackSwapSelectionStarted
  | typeof trackSwapFunnelStarted
  | typeof trackSwapFunnelGradingCompleted
  | typeof trackSwapFunnelShippingCompleted
  | typeof trackSwapFunnelPaymentCompleted;

export const useTrackSwap = () => {
  const [order] = useTrackSwapLazyQuery({ fetchPolicy: "network-only" });

  const track =
    (trackingFunction: TrackingFunction) =>
    (orderId: number, extraParams: Record<string, any> = {}) =>
      order({ variables: { orderId } }).then(
        ({ data }) =>
          data?.order &&
          trackingFunction(
            {
              ...fromOrder(data.order),
              ...extraParams,
            },
            fromCustomer(data.customer),
          ),
      );

  return {
    trackSwapStarted: track(trackSwapStarted),
    trackSwapSelectionStarted: track(trackSwapSelectionStarted),
    trackSwapFunnelStarted: track(trackSwapFunnelStarted),
    trackSwapFunnelGradingCompleted: track(trackSwapFunnelGradingCompleted),
    trackSwapFunnelShippingCompleted: track(trackSwapFunnelShippingCompleted),
    trackSwapFunnelPaymentCompleted: track(trackSwapFunnelPaymentCompleted),
  };
};
